const inPageNav = () => {
  // Fixed navbar behavior
  const headerDiv = document.querySelector('.header');
  const anchors = document.querySelectorAll('.page-anchor');
  const inPageNavDiv = document.querySelector('.in-page-nav:not([data-in-page-nav-static])');
  const mainContentDiv = document.getElementById('main-content');
  const footerDiv = document.querySelector('.c-footer');
  let initLoadHeaderOffset = 24;
  if (headerDiv === null || inPageNavDiv === null) {
    return;
  }
  const inPageNavYPos = inPageNavDiv.offsetTop;
  const updateOffsetHeight = () => {
    let headerFixedOffset = 0;
    const headerOffset = headerDiv.offsetHeight;
    let addFixedAtY = inPageNavYPos - headerOffset;
    // Check if header is fixed
    const headerStyles = window.getComputedStyle(headerDiv);
    if (headerStyles.getPropertyValue('position').toLowerCase() === 'fixed') {
      addFixedAtY = inPageNavYPos - headerOffset;
    }
    if (addFixedAtY <= window.scrollY) {
      headerFixedOffset = Math.min(window.scrollY - addFixedAtY, headerDiv.offsetHeight) * -1;
      inPageNavDiv.classList.add('is-fixed');
      inPageNavDiv.style.top = `${headerOffset + headerFixedOffset}px`;
      // console.log(`${headerFixedOffset}px`);
      // Slide up header and in-page nav,
      // so in-page nav is locked to top of screen
      headerDiv.style.top = `${headerFixedOffset}px`;
    } else {
      inPageNavDiv.classList.remove('is-fixed');
      inPageNavDiv.removeAttribute('style');
      headerDiv.removeAttribute('style');
    }
  };

  // Scrolling & Anchors
  const updateAnchorOffset = () => {
    const offset = `${(-inPageNavDiv.clientHeight)}px`;
    for (let i = 0; i < anchors.length; i++) { /* eslint-disable-line no-plusplus */
      anchors[i].style.top = offset;
    }
    // Reset to 0 after applying on load
    if (initLoadHeaderOffset !== 0) {
      initLoadHeaderOffset = 0;
    }
  };

  const getAnchorPosition = (anchor) => {
    const div = document.querySelector(`a[data-anchor-name="${anchor}"]`);
    if (div) {
      if (!inPageNavDiv.classList.contains('is-fixed')) {
        return div.offsetTop - 60;
      }
      return div.offsetTop;
    }
    return 0;
  };

  const scrollToPosition = (pos) => {
    window.scrollTo({
      top: pos,
      behavior: 'smooth',
    });
  };

  const updateHashAfterDelay = (anchor) => {
    setTimeout(() => {
      window.location.hash = anchor;
    }, 250);
  };

  const getDocumentHeight = () => (
    footerDiv.offsetHeight + mainContentDiv.offsetHeight
  );

  window.addEventListener('resize', () => {
    updateAnchorOffset();
  });

  window.addEventListener('scroll', () => {
    updateOffsetHeight();
    // Catch page bottom
    if ((window.innerHeight + window.scrollY >= window.getDocumentHeight()) && anchors.length > 0) {
      const anchorName = anchors[anchors.length - 1].getAttribute('data-anchor-name');
      let setAsActive = inPageNavDiv.querySelector(`[href*="#${anchorName}"]`);
      if (setAsActive === null) {
        return;
      }
      setAsActive = setAsActive.parentNode;
      // If nav item is already active, return
      if (setAsActive.classList.contains('active')) {
        return;
      }
      // Remove active state
      const currentActive = inPageNavDiv.querySelector('.active');
      if (currentActive) {
        currentActive.classList.remove('active');
      }
      // Set new active and update hash
      setAsActive.classList.add('active');
      updateHashAfterDelay(anchorName);
      return;
    }
    window.updateAnchorOffset(); // Weird scope issue, so added reference to window
    for (let i = anchors.length - 1; i >= 0; i--) { /* eslint-disable-line no-plusplus */
      // console.log(`${i}. ${anchors[i].offsetTop}/${window.scrollY}`);
      if (anchors[i].offsetTop <= window.scrollY) {
        const anchorName = anchors[i].getAttribute('data-anchor-name');
        let setAsActive = inPageNavDiv.querySelector(`[href*="#${anchorName}"]`);
        if (setAsActive === null) {
          return;
        }
        setAsActive = setAsActive.parentNode;
        // If nav item is already active, return
        if (setAsActive.classList.contains('active')) {
          return;
        }
        // Remove active state
        const currentActive = inPageNavDiv.querySelector('.active');
        if (currentActive) {
          currentActive.classList.remove('active');
        }
        // Set new active and update hash
        setAsActive.classList.add('active');
        updateHashAfterDelay(anchorName);
        return;
      }
    }
  });

  // Load
  updateOffsetHeight();
  updateAnchorOffset();
  window.updateAnchorOffset = updateAnchorOffset;
  window.getDocumentHeight = getDocumentHeight;
  // Check to see if url is hashed and if hash matches page anchor
  if (window.location.hash) {
    const anchor = window.location.hash.substr(1);
    const pos = getAnchorPosition(anchor);
    scrollToPosition(pos);
    if (pos !== 0) {
      updateHashAfterDelay(anchor);
    }
  }

  // Event handlers
  [].map.call(document.querySelectorAll('a, .in-page-nav-item button'), btn => (
    btn.addEventListener('click', (event) => {
      let anchor = btn.getAttribute('href');
      if (anchor) {
        const url = window.location.href;
        const urlMatch = anchor.substring(0, anchor.indexOf('#')) === url.substr(0, url.indexOf('#'));
        if (anchor.indexOf('#') === 0 || (anchor.indexOf('#') !== -1 && urlMatch)) {
          event.preventDefault();
          anchor = anchor.substr(anchor.indexOf('#') + 1);
          const pos = getAnchorPosition(anchor);
          scrollToPosition(pos);
          if (pos !== 0) {
            updateHashAfterDelay(anchor);
          }
        }
      }
    })
  ));
};

export default inPageNav;
